<div><slot :sign-out="signOut"></slot></div>